// @ts-nocheck

import React from 'react';
import { connect } from 'react-redux';
import includes from 'lodash/includes';
import PropTypes from 'prop-types';
import { yieldCallback } from '@zillow/yield-callback';

import { trackPayPerClick } from 'app/client/tracking';
import AppActions from 'app/shared/flux/actions/AppActions';
import Linker from 'app/shared/modules/Linker';
import { listingUtils_shouldShowPpcLink } from 'app/shared/utils/listingUtils';
import {
  emitTrackBuildingPayPerLinkClickEvent,
  emitTrackLowerPpcClickEvent,
  emitTrackUpperPpcClickEvent,
} from 'app/shared/models/Clickstream/HdpClickstreamEvents';
import { StyledPpcLinkIcon, StyledPpcLinkTarget, StyledPpcLinkWrapper } from './PpcLink.styles';
import NewWindowTealIcon from 'images/icons/new-window-teal.svg';
class PpcLink extends React.Component {
  static propTypes = {
    device: PropTypes.object,
    listing: PropTypes.object,
    ppcLocation: PropTypes.oneOf(['address', 'hdp', 'summary']),
  };

  constructor(props) {
    super(props);
  }

  handlePpcClick = yieldCallback(() => {
    this.props.dispatch(AppActions.sendEventToApi('companyWebsiteVisited'));

    if (this.props.ppcLocation === 'address') {
      emitTrackUpperPpcClickEvent();
      emitTrackBuildingPayPerLinkClickEvent({ triggerObject: 'home_details_component|summary' });
    } else if (this.props.ppcLocation === 'hdp') {
      emitTrackLowerPpcClickEvent();
      emitTrackBuildingPayPerLinkClickEvent({
        triggerObject: 'home_details_component|property_details',
      });
    }
    trackPayPerClick(this.props.listing);
  });

  render() {
    const { device, linkText, listing } = this.props;
    const details = listing.details || {};
    const shouldShowPpcLink = listingUtils_shouldShowPpcLink(details, device);
    let website;

    // Disable PPC links on mobile devices.
    if (shouldShowPpcLink) {
      website = details.webSiteOriginalDomain ? 'Visit ' + details.webSiteOriginalDomain : "Visit Property's Website";
      const isUglyDomain =
        website.split('.').length > 3 || includes(website, 'prospectportal') || includes(website, 'reslisting');

      if (isUglyDomain) {
        website = "Visit Property's Website";
      }

      // the double <span> around the Linker is necessary for hyperlink elipses truncation
      return (
        <StyledPpcLinkWrapper>
          <StyledPpcLinkTarget>
            <StyledPpcLinkTarget>
              <Linker
                to={details.webSite}
                onClick={this.handlePpcClick}
                rel="nofollow"
                target="_blank"
                removeNoOpener
                removeNoReferrer
              >
                {linkText || website}
                <StyledPpcLinkIcon src={NewWindowTealIcon} alt="" />
              </Linker>
            </StyledPpcLinkTarget>
          </StyledPpcLinkTarget>
        </StyledPpcLinkWrapper>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  device: state.app.device,
});

export default connect(mapStateToProps)(PpcLink);
